/* InkMerge Studio — Phase 1 Ship product catalog.
 * Single launch product: Premium Garment-Dyed Tee.
 * Safety bootstrap: on the Studio route, direct JSON cart writes are blocked
 * until the native production-attachment layer takes over. If that asset ever
 * fails to load, a custom order fails closed instead of entering cart without
 * production artwork.
 */
(function () {
  var studioPath = window.location.pathname.replace(/\/+$/, '') === '/pages/customize-tee';
  if (studioPath && !window.__IM_STUDIO_CART_BOOTSTRAP_20260816__) {
    window.__IM_STUDIO_CART_BOOTSTRAP_20260816__ = true;
    var rawFetch = window.fetch.bind(window);
    window.__IM_STUDIO_RAW_FETCH = rawFetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = String(input instanceof Request ? input.url : input); } catch (_e) {}
      var directStudioJsonCart = url.indexOf('/cart/add.js') !== -1 && init && typeof init.body === 'string';
      if (directStudioJsonCart) {
        return Promise.resolve(new Response(JSON.stringify({
          description: 'Studio production attachment is still loading. No custom order was added. Please try again.'
        }), { status: 425, headers: { 'Content-Type': 'application/json' } }));
      }
      return rawFetch(input, init);
    };

    try {
      var current = document.currentScript;
      if (current && current.src) {
        var nativeUrl = new URL(current.src, window.location.href);
        nativeUrl.pathname = nativeUrl.pathname.replace(/inkmerge-studio-data\.js$/, 'inkmerge-studio-native-cart-20260809.js');
        nativeUrl.search = '';
        nativeUrl.searchParams.set('v', '68d130c15ea2ed9ab0442fcc6f0ee870');
        var nativeScript = document.createElement('script');
        nativeScript.src = nativeUrl.toString();
        nativeScript.async = false;
        nativeScript.dataset.imStudioNativeCart = 'true';
        nativeScript.onerror = function () { console.error('[InkMerge Studio] Production attachment layer failed to load; cart remains fail-closed.'); };
        document.head.appendChild(nativeScript);
      }
    } catch (error) {
      console.error('[InkMerge Studio] Could not start production attachment layer; cart remains fail-closed.', error);
    }
  }

  const COLORS = {
    Pepper: { hex: '#5B5147' },
    Ivory: { hex: '#F2EAD9', light: true },
    Black: { hex: '#1B1A19' },
    Graphite: { hex: '#41423E' },
    'Blue Jean': { hex: '#6B8AAE' },
    Moss: { hex: '#6B7546' },
    Chambray: { hex: '#93A6B4', light: true },
    Bay: { hex: '#4D6B6D' },
    Orchid: { hex: '#B086A8', light: true },
    Berry: { hex: '#6E2944' },
    Blossom: { hex: '#F0C7C0', light: true },
    'Flo Blue': { hex: '#4D7BAD' },
    Violet: { hex: '#574270' },
    Watermelon: { hex: '#C84A55' },
    Yam: { hex: '#B86B3B' }
  };

  function c(names) {
    return names.map((n) => {
      const slug = n.toLowerCase().replace(/\s+/g, '-');
      return { name: n, photo: slug, ...COLORS[n] };
    });
  }

  const PRODUCTS = [
    {
      key: 'premium-garment-dyed-tee',
      hasPhotos: true,
      flatlay: true,
      photoAspect: '5 / 4',
      title: 'Premium Garment-Dyed Tee',
      category: 'Premium Garment-Dyed Tee',
      icon: 'tee',
      desc: 'Soft, heavyweight, garment-dyed premium cotton with a relaxed unisex fit and vintage feel.',
      fit: 'Relaxed unisex fit · garment-dyed · compare the size chart before ordering',
      locations: ['front', 'pocket'],
      colors: c(['Pepper','Ivory','Black','Graphite','Blue Jean','Moss','Chambray','Bay','Orchid','Berry','Blossom','Flo Blue','Violet','Watermelon','Yam']),
      sizes: [
        { size: 'S', price: 34.95 },
        { size: 'M', price: 34.95 },
        { size: 'L', price: 34.95 },
        { size: 'XL', price: 36.95 },
        { size: '2XL', price: 38.95 }
      ],
      chart: [
        { size: 'S', width: 18, length: 28 },
        { size: 'M', width: 20, length: 29 },
        { size: 'L', width: 22, length: 30 },
        { size: 'XL', width: 24, length: 31 },
        { size: '2XL', width: 26, length: 32 }
      ]
    }
  ];

  window.IM_DATA = { COLORS: COLORS, PRODUCTS: PRODUCTS };
})();
